import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
const HERO_URL = "https://cdn.magicpatterns.com/uploads/4mQVXyQCDaLGqFgcxpbsZV/ChatGPT_Image_Sep_16,_2026,_06_41_37_PM.png";

// Start fetching the hero banner (the page's largest paint) before React mounts.
const preload = document.createElement("link");
preload.rel = "preload";
preload.as = "image";
preload.href = HERO_URL;
preload.setAttribute("fetchpriority", "high");
document.head.appendChild(preload);

// Load the display typeface without blocking first render.
const fonts = document.createElement("link");
fonts.rel = "stylesheet";
fonts.href = "https://fonts.googleapis.com/css2?family=Saira:wght@700&display=swap";
fonts.media = "print";
fonts.onload = () => {
  fonts.media = "all";
};
document.head.appendChild(fonts);
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-53" data-mp="2y19mrhe2d36x" />);
}